import _defineProperty from '@babel/runtime/helpers/defineProperty';
import BN from 'bn.js';

class Share {
  constructor(shareIndex, share) {
    _defineProperty(this, "share", void 0);
    _defineProperty(this, "shareIndex", void 0);
    this.share = new BN(share, "hex");
    this.shareIndex = new BN(shareIndex, "hex");
  }
  static fromJSON(value) {
    const {
      share,
      shareIndex
    } = value;
    return new Share(shareIndex, share);
  }
  toJSON() {
    return {
      share: this.share.toString("hex"),
      shareIndex: this.shareIndex.toString("hex")
    };
  }
}
var Share$1 = Share;

export { Share$1 as default };
